module.exports = __webpack_public_path__ + "static/img/sportGame4.b186801.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/sportGame4.png
// module id = VlC5
// module chunks = 3